import * as React from "react";
import {cs} from "../../../../../../../../react/chain-services";
import "./search-result.scss";
import {StreetsBox} from "./streets-box/streets-box";
import {UseState} from "../../../../../../../../react/use-state";
import {IndividualStreets} from "./individual-streets/individual-streets";
import {sum} from "../../../../../../../../utils/collections";
import {isApiTrue} from "../../../../../../../../logic/is-api-true";

export const SearchResult = ({streets, next: rootNext}) => cs(
    ["searchState", (_, next) => UseState({
        next,
    })],
    ["streetsBox", ({searchState}, next) => StreetsBox({
        data: streets,
        searchState,
        next
    })],
    ["containsAddresses", ({}, next) => next(
        sum(streets.value, (r) => (
            r.excluded ? 0 : (
                r.addresses.filter((a) => isApiTrue(a.display_address)).length
            )
        ))
    )],
    ({searchState, containsAddresses, streetsBox}) => rootNext({
        valid: containsAddresses && streetsBox.valid,

        highlightErrors: () => {
            streetsBox.highlightErrors();
        },
        
        render: () => (
            <div className="search-result-6w2">

                <div className="header">
                    <div className="line1">
                        <div className="title" xd-qa-type="label" xd-qa-name="Build Street List Selected Streets">
                            Selected Streets
                        </div>
                    </div>
                    <div className="sub-title" xd-qa-type="label" xd-qa-name="Build Street List Selected Streets Description">
                        Choose which streets you want to include in your list.
                    </div>
                </div>

                {streetsBox.render()}

                {searchState.value && (
                    IndividualStreets({
                        searching: searchState.value,
                        data: streets,
                    })
                )}

            </div>
        )
    }),
);